const types = {
    BLOWING: "nawiew",
    EXHAUST: "wywiew"
}

export {types}
